import { InitFeature } from 'features/Init'
import { LayoutFeature } from 'features/Layout'
import { SchedulesFeature } from 'features/Schedules'
import { IFeature } from 'types'

export const appFeatures: IFeature[] = [InitFeature, LayoutFeature, SchedulesFeature]
